import { Component, computed, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IconLabelComponent } from '../../../../atoms/icon-label/icon-label.component';
import { BreadcrumbTruncate } from '../../breadcrumb.interfaces';
import { ViewportService } from 'shared';

@Component({
  selector: 'ocp-breadcrumb-item',
  imports: [IconLabelComponent, RouterLink],
  styles: `
    :host {
      cursor: pointer;
      min-width: 0;

      &:focus-visible {
        outline-offset: 0;
        border-radius: var(--radius-lg);
      }
    }
  `,
  template: `
    <ocp-icon-label
      [iconSrc]="iconSrc()"
      [label]="label()"
      [routerLink]="routerLink()"
      queryParamsHandling="preserve"
      [minWidth]="minWidth()"
      [maxWidth]="maxWidth()"
    />
  `,
})
export class BreadcrumbItemComponent {
  protected readonly viewportService = inject(ViewportService);
  protected readonly isMobile = this.viewportService.isMobile();
  iconSrc = input('');
  label = input('');
  routerLink = input('');
  truncate = input<BreadcrumbTruncate>();

  protected readonly minWidth = computed(() => {
    if (this.viewportService.isMobile()) {
      return this.truncate()?.minWidth;
    }

    return '';
  });

  protected readonly maxWidth = computed(() => {
    if (this.viewportService.isMobile()) {
      return this.truncate()?.maxWidth;
    }

    return '';
  });
}
